import { useDialogConfirm } from '@src/components/Common/Dialog';
import MicrophoneError from '@src/logic/errors/microphoneError';
import { useIntl } from 'react-intl';
import { destroySession } from '../../callSession';

const useHandleCallMediaError = () => {
  const { formatMessage } = useIntl();
  const dialogConfirm = useDialogConfirm();

  return (error: unknown): void => {
    if (error instanceof MicrophoneError) {
      dialogConfirm({
        disableBackdropClose: true,
        title: formatMessage({ id: 'Calling.MicrophoneFaile.TitleLbl' }),
        description: [
          formatMessage({ id: 'Calling.MicrophoneFaile.ContentLbl1' }),
          formatMessage({ id: 'Calling.MicrophoneFaile.ContentLbl2' }),
        ],
      });
    } else {
      destroySession();
      dialogConfirm({
        disableBackdropClose: true,
        title: formatMessage({ id: 'Calling.CallNotEstablished.TitleLbl' }),
        description: formatMessage({
          id: 'Calling.CallNotEstablished.ContentLbl',
        }),
      });
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
};

export default useHandleCallMediaError;
